import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from 'img/home/qualification/left.png'
import _imports_1 from 'img/home/qualification/right.png'
import _imports_2 from 'img/home/qualification/bg.png'


const _withScopeId = n => (_pushScopeId("data-v-33072306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Qualification" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "企业资质"),
  /*#__PURE__*/_createElementVNode("span", { class: "caption-en" }, "ENTERPRISE QUALIFICATION")
], -1))
const _hoisted_3 = { class: "qualification-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qualification-left",
  src: _imports_0,
  alt: "左边",
  width: "66"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qualification-right",
  src: _imports_1,
  alt: "右边",
  width: "66"
}, null, -1))
const _hoisted_6 = { class: "qualification-swiper" }
const _hoisted_7 = { class: "qualification-edge" }
const _hoisted_8 = { class: "qualification-num" }
const _hoisted_9 = { class: "qualification-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification-dot" }, null, -1))
const _hoisted_11 = { class: "qualification-desc" }
const _hoisted_12 = { class: "qualification-center" }
const _hoisted_13 = { class: "qualification-img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qualification-bg",
  src: _imports_2
}, null, -1))
const _hoisted_16 = { class: "qualification-inside" }
const _hoisted_17 = { class: "qualification-num" }
const _hoisted_18 = { class: "qualification-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification-dot" }, null, -1))
const _hoisted_20 = { class: "qualification-desc" }
const _hoisted_21 = { class: "qualification-edge" }
const _hoisted_22 = { class: "qualification-num" }
const _hoisted_23 = { class: "qualification-title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification-dot" }, null, -1))
const _hoisted_25 = { class: "qualification-desc" }

import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Navigation } from 'swiper'

export default {
  setup(__props) {

SwiperCore.use([Navigation]);
const introduce = [{
  title: '呼叫中心增值电信业务许可证',
  desc: '获得此证是工信部对我司业务合规性的认可，有利于规范呼叫中心经营行为，促进平台合规稳健发展。同时，我司内部“网站备案系统”、 “接入资源管理平台”、“信息安全系统”三套系统通过工信部评测，获得ISP增值电信业务许可证。该许可证是企业对外开展数据中心业务、提供互联网接入服务的必备资质条件。',
  img: '0.png'
}, {
  title: 'ISO27001 信息安全管理体系认证',
  desc: '互连众信已经建立一套科学有效的管理体系。引入信息安全管理体系使企业相关的信息安全管理工作更规范，保护信息化进程健康、有序、可持续发展，从而确保企业信息服务的安全稳定运行。',
  img: '1.png'
}, {
  title: ' ISO20000 信息技术服务管理体系认证',
  desc: '我司的IT服务管理水平和信息安全能力再次得到认可，已具备为广大用户提供更高质量、更加安全、更有效率的软硬件运维服务的相关能力。我公司将继续致力于信息技术服务管理体系的完善和提高，引领企业不断发展。',
  img: '2.png'
}, {
  title: 'ISO9001质量管理体系认证',
  desc: '质量管理体系认证证书的取得，是公司各项管理工作的规范化、标准化的全面检测，是对公司持续稳定健康发展的重要保证。质量管理体系的建立和贯彻运行，将有助于公司不断提升质量管理水平，在市场竞争中树立良好的企业形象和信誉。',
  img: '3.png'
}, {
  title: 'ISO22301业务连续性管理体系认证',
  desc: '业务连续性管理体系的建立和改进为我司提供了一套完整通用的框架，帮助我司更好的辨别和分析潜在的问题，并提供行之有效的管理机制来应对突发事件。\n' +
      '在获得该认证后，我司仍将不断提高业务连续性管理能力，进一步加强公司的运营弹性，为客户带来高质量、高效率的服务。',
  img: '4.png'
}, {
  title: '国家专利《全生命周期不良资产管理系统》',
  desc: '发明实施案例公开了一种资产管理方法。提出的资产管理系统及资产管理方法对不良资产实现了全生命周期的资产管理，可以防范不良资产的产生，并可以根据不良资产的全生命周期不同阶段提供定制化的处理方案。',
  img: '5.png'
}, {
  title: '国家专利《语义识别方法、装置、存储介质及处理器》',
  desc: '本申请公开了一种语义识别方法、装置、存储介质及处理器。该方法包括：将待识别的目标音频数据转化为目标字符串，其中，目标音频数据为通话发起对象和通话接收对象之间的通话音频数据；将目标字符串输入语义分析模型，得到多个标签，其中，语义分析模型包括多个子模型，每个子模型用于预测目标字符串是否归属于子模型描述的标签，每个标签用于表征一种类型的目标语义信息。',
  img: '6.png'
}]

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Swiper), {
        initialSlide: 0,
        speed: 1000,
        loop: true,
        navigation: {prevEl:'.qualification-left',nextEl:'.qualification-right'}
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(introduce, (item, i) => {
            return _createVNode(_unref(SwiperSlide), { key: i }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, "0" + _toDisplayString(i===0?7:i), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(introduce[i===0?6:i-1].title), 1),
                    _hoisted_10,
                    _createElementVNode("p", _hoisted_11, _toDisplayString(introduce[i===0?6:i-1].desc), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        class: "qualification-certificate",
                        src: require('img/home/qualification/'+introduce[i].img),
                        alt: "证书",
                        width: "290",
                        draggable: "false",
                        onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, null, 40, _hoisted_14),
                      _hoisted_15
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createTextVNode("0" + _toDisplayString(i+1), 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(introduce[i].title), 1)
                      ]),
                      _hoisted_19,
                      _createElementVNode("p", _hoisted_20, _toDisplayString(introduce[i].desc), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, "0" + _toDisplayString(i===6?1:i+2), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(introduce[i===6?0:i+1].title), 1),
                    _hoisted_24,
                    _createElementVNode("p", _hoisted_25, _toDisplayString(introduce[i===6?0:i+1].desc), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      }, 8, ["navigation"])
    ])
  ]))
}
}

}